module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/point_maedori_03-0e7693dc640d97e4aa42efc91fb258dd.webp";